import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftonedriveComponent } from './simple-icons-microsoftonedrive.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftonedriveComponent ],
    exports:      [ SimpleIconsMicrosoftonedriveComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftonedriveModule {}
